import React from 'react';

import './Enemies.scss';

const Enemies = ({ children }) =>(
  <div className="enemies">
    {children}
  </div>
);

export default Enemies;
